export function StatsCard({ Title, stats, customHeight }) {
  return (
    <div
      className={`gap-2 py-2 flex flex-col rounded-xl bg-white justify-center h-24 items-center flex-1 ${customHeight}`}
    >
      <span className="lg:text-base text-center">{Title}</span>
      <span className="text-2xl font-semibold">{stats}</span>
    </div>
  );
}
